import { z } from "zod";
import { ConstructionPlanBaseSchema } from "../generated/ConstructionPlan";
import { GroupBaseSchema } from "../generated/Group";
import { WorkBaseSchema } from "../generated/Work";
import { getUserSchema } from "./user";

export const constructionPlanRowSchema = ConstructionPlanBaseSchema.base.extend({
  // 工事は Work。Work は担当者を持たないため User ネストは無い。work_id が null なら null 相当。
  Work: WorkBaseSchema.base.nullable(),
  User: getUserSchema.strip(),
});
export const constructionPlanRowsSchema = z.array(constructionPlanRowSchema);
export type constructionPlanRow = z.infer<typeof constructionPlanRowSchema>;
export type constructionPlanRows = z.infer<typeof constructionPlanRowsSchema>;

// 施工計画の正規化応答(重複排除)。従来の Work(工事)・User ネストを related バケットへ
// 分離し、ネスト形(constructionPlanRow)への復元は web 側 util/hydrators/constructionPlanHydrator が行う。
// キー名は IndexedDB の SetCache 収集キー(PascalCase 複数形)に合わせてある。
// related.Works には従来 include の where(deleted_at: null)を踏襲して alive の行のみ入る
// (削除済みの参照先は従来どおりネスト null 相当)。
// 単一取得(get-construction-plan-from-id)も同形(ConstructionPlans 配列に1件)で返し、応答組み立てを共有する。
export const normalizedConstructionPlanResponseSchema = z.object({
  ConstructionPlans: ConstructionPlanBaseSchema.base.array(),
  related: z.object({
    Works: WorkBaseSchema.base.array(),
    // User 内の Group ネストも一般規則どおり分離する(Users は group_id 参照のみ)
    Users: getUserSchema.omit({ Group: true }).strip().array(),
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedConstructionPlanResponse = z.infer<typeof normalizedConstructionPlanResponseSchema>;
